import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_COLOR_GALLERY = gql(`
  query FetchColorGallery($productGroupHandle: String!) {
    productGroup(handle: $productGroupHandle) {
        colorGroups {
            label
            colors {
                rawName
            }
        }
        products {
            handle
            images(first: 1) {
                nodes {
                    source
                }
            }
            colorInfo {
                rawName
                name
            }
        }
    }
  }
`)
